import { Form, SelectInput } from '@thinknet-gmbh/platform-common-ui';

import { IEmployeesListProps } from 'src/pages/jobs/components/job-form/job-form.interfaces';

const JobEmployeesList = ({
  locationField,
  initialValues,
  supervisorField,
}: IEmployeesListProps) => (
  <Form.List name={[supervisorField, 'employees']}>
    {fields => (
      <div>
        {fields.map(field => (
          <div key={field.key}>
            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue }) => {
                if (!initialValues) return;

                const initialEmployee =
                  initialValues.jobLocations[locationField].jobSupervisors[supervisorField]
                    // .employees[field.name];
                const currentEmployee = getFieldValue([
                  'jobLocations',
                  locationField,
                  'supervisors',
                  supervisorField,
                  'employees',
                  field.name,
                ]);

                return (
                  <Form.Item name={[field.name, '_id']} label="Assigned employee">
                    <SelectInput
                      placeholder="Find employee to set job"
                      disabled={currentEmployee && initialEmployee._id === currentEmployee._id}
                    >
                      <SelectInput.Option value="1-1-1-1">John Wick</SelectInput.Option>
                      <SelectInput.Option value="1-1-1-2">Connor McGregor</SelectInput.Option>
                    </SelectInput>
                  </Form.Item>
                );
              }}
            </Form.Item>
          </div>
        ))}
      </div>
    )}
  </Form.List>
);

export default JobEmployeesList;
